import { get, post, put, del } from './api';

// Create a new customer
export const createCustomer = (data) => {
  return post('/customers', data);
};

export const getAllCustomers = (
  page = 1,
  limit = 10,
  search = '',
  sortField = 'id',
  sortOrder = 'desc'
) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (search) params.append('name', search);
  if (sortField) params.append('sort_field', sortField);
  if (sortOrder) params.append('sort_order', sortOrder);

  return get(`/customers?${params.toString()}`);
};


// Get a customer by ID
export const getCustomerById = (id) => {
  return get(`/customers/${id}`);
};

// Update a customer
export const updateCustomer = (id, data) => {
  return put(`/customers/${id}`, data);
};

// Delete a customer (soft delete if your backend supports it)
export const deleteCustomer = (id) => {
  return del(`/customers/${id}`);
};

// gst 
export const fetchCustomerByGST = (gstNumber) => {
  return get(`/customers/gst/${gstNumber}`);
};